import { Label, LabelProps } from './label'

export { Label }
export type { LabelProps }
